import React from "react";
import { Form, Label } from "semantic-ui-react";

const TextInput = ({
  input,
  width,
  type,
  placeholder,
  meta: { touched, error },
  disabled,
  maxLength,
  handleOnChange,
}) => {
  return (
    <Form.Field
      error={touched && !!error}
      type={type}
      width={width}
      disabled={disabled}
      onChange={(event) => {
        input.onChange(event.target.value);
        if (handleOnChange) handleOnChange(event.target.value);
      }}
    >
      <input {...input} placeholder={placeholder} maxLength={maxLength} />
      {touched && error && (
        <Label basic color="red" pointing>
          {error}
        </Label>
      )}
    </Form.Field>
  );
};

export default TextInput;
